const isGtmEnabled = import.meta.env.VITE_ACTIVE_ENV !== "development"

export function GoogleTagManager() {
  if (!isGtmEnabled) return null

  return (
    <>
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=UA-462630-12"
      />
      <script>{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'UA-462630-12');
          gtag('config', 'G-VW8R0GFNXH');
        `}</script>
    </>
  )
}
